import { create } from 'zustand';
import {
  SingleShiftTemplateCreateData,
  SingleShiftTemplateEditData,
  createSingleShiftTemplate,
  deleteSingleShiftTemplate,
  updateSingleShiftTemplate,
} from '@libs/api/shiftTemplates';
import { ShiftTemplate } from '@libs/models/shiftTemplates/template';

type InitialState = {
  open: boolean;
  loading: boolean;
  drawerMode: 'create' | 'edit' | 'copy';
  currentEntityId: string;
  entity: ShiftTemplate | null;

  create: (data: SingleShiftTemplateCreateData) => Promise<void>;
  update: (data: SingleShiftTemplateEditData) => Promise<void>;
  delete: (id: string) => Promise<void>;
  openDrawer: (id?: string, entity?: ShiftTemplate, mode?: 'create' | 'edit' | 'copy') => void;
  closeDrawer: () => void;
};

export const useShiftTemplateDrawerStore = create<InitialState>()((set) => ({
  open: false,
  loading: false,
  drawerMode: 'create',
  currentEntityId: '',
  entity: null,

  create: async (data: SingleShiftTemplateCreateData) => {
    set({ loading: true });
    try {
      await createSingleShiftTemplate(data);
    } catch (error) {
      console.error('Error creating shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  update: async (data: SingleShiftTemplateEditData) => {
    set({ loading: true });
    try {
      await updateSingleShiftTemplate(data);
    } catch (error) {
      console.error('Error updating shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  delete: async (id: string) => {
    set({ loading: true });
    try {
      await deleteSingleShiftTemplate(id);
    } catch (error) {
      console.error('Error deleting shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },

  openDrawer: (id = undefined, entity = undefined, mode = undefined) => {
    const drawerMode = id ? 'edit' : 'create';
    set({ open: true, currentEntityId: id || '', entity: entity || null, drawerMode: mode || drawerMode });
  },
  closeDrawer: () => {
    set({ open: false, currentEntityId: '', entity: null });
  },
}));
